import _G_ from './SetValueConstant';


_G_.defaultLocale = 'en';
_G_.locale = 'en';
_G_.RTL = false;
_G_.fallbacks = true;
_G_.noShowInstallPwa = false;

export default _G_;
